const instructorReducer = (state = {}, action) => {
    switch (action.type) {
        case 'SWITCH_GROUP':
            return {
                ...state,
                ...action.payload
            }
        case 'REFRESH_GROUPS':
            return {
                ...state,
                ...action.payload
            }
        case 'SWITCH_TOPIC':
            return {
                ...state,
                ...action.payload
            }
        case 'FILTER_BY_STUDENT':
            return {
                ...state,
                ...action.payload
            }
        case 'SORT_STUDENTS_BY_WRONG_ANSWERS':
            return {
                ...state,
                ...action.payload
            }
        default:
            return state
    }
}

export default instructorReducer